import React from 'react';
import PropTypes from 'prop-types';
import { defaultStyles } from 'utils/Theme';
import { useSelector } from 'react-redux';
import { Grid, Tooltip, IconButton } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import * as Icon from 'react-feather';

const DynamicAppsTableActions = ({ id, qsApp }) => {
    const history = useHistory();
    const classes = defaultStyles();
    const { hostname, prefix } = useSelector(
        (state) => state.qsServer.qsServer
    );

    const qsAppLink = `https://${hostname}/${prefix}/sense/app/${qsApp}/overview`;

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            style={{ padding: 10 }}
        >
            <Grid item>
                <Tooltip title="View" placement="top">
                    <IconButton
                        onClick={() =>
                            history.push(
                                `/settings/dag/dynamic-apps/${id}/view`
                            )
                        }
                        className={classes.colorPrimary}
                    >
                        <Icon.Eye size={16} />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item>
                <Tooltip title={`Open in Qlik Sense`} placement="top">
                    <IconButton
                        onClick={() => {
                            window.open(qsAppLink);
                        }}
                        className={classes.colorInfo}
                    >
                        <Icon.ExternalLink size={16} />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
};

DynamicAppsTableActions.propTypes = {
    id: PropTypes.string.isRequired,
    qsApp: PropTypes.string.isRequired,
};

export default DynamicAppsTableActions;
